<template lang="html">
  <div>
    <footer class="main-footer">
      <div class="pull-right hidden-xs">
        <b>Versão</b>
        <!--0.0.0-->
        {{ version }}
      </div>
      <strong
        >Copyright &copy; {{ year }}
        <a href="http://planosassessoria.com.br">Planos Assessoria</a>.</strong
      >
      Todos os direitos reservados.
    </footer>
  </div>
</template>

<script>
import { version } from '../../package.json'

export default {
  name: 'main-footer',
  data() {
    return {
      year: new Date().getFullYear(),
      version: version
    }
  }
}
</script>
